import React, { useEffect, useState } from "react";
import { Component } from "./DynamicComponents";

const Base = ({ componentName }) => {
    const [selectedSection, setSelectedSection] = useState(componentName ?? "");
    useEffect(() => {
        setSelectedSection(componentName);
    }, [componentName]);
    return (
        <Component {...{ selectedSection, setSelectedSection }} />
    );
};

export default Base;
